import React from "react";
import { ShieldCheck, Target, Briefcase, Scale } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EngagementsValeurs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const values = [{
    title: "Confiance Institutionnelle",
    description: "Un positionnement crédible et éthique pour bâtir des relations durables avec nos partenaires.",
    icon: <ShieldCheck className="size-6 text-primary" />
  }, {
    title: "Culture du Résultat",
    description: "Une approche pragmatique orientée vers l'atteinte d'objectifs concrets et mesurables.",
    icon: <Target className="size-6 text-primary" />
  }, {
    title: "Expertise B2B",
    description: "Une maîtrise pointue des codes et exigences des organisations professionnelles.",
    icon: <Briefcase className="size-6 text-primary" />
  }, {
    title: "Rigueur Méthodologique",
    description: "Des processus structurés et fluides garantissant l'excellence opérationnelle.",
    icon: <Scale className="size-6 text-primary" />
  }];
  return <section id="engagements-valeurs" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,hsl(var(--muted)/0.1),transparent_70%)] pointer-events-none" />
      
      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          
          {}
          <div className="col-span-1 lg:col-span-5 flex flex-row items-start gap-6 lg:sticky lg:top-32 h-fit">
            <div className="w-2 h-32 lg:h-48 bg-primary shrink-0 rounded-full shadow-[0_0_15px_rgba(234,179,8,0.3)]" />
            <div className="pt-2">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight tracking-tight mb-6">Nos<br />Engagements <br /><span className="text-muted-foreground" data-ast-id="f:/src/pages/Home/sections/EngagementsValeurs.tsx|sig:6hjyc0" data-ast-start="2139" data-ast-end="2316">&amp; Valeurs</span></h2>
              <p className="text-lg max-w-md leading-relaxed !text-[hsl(0,0%,100%)]">
                Chez Freelance Com & Event, nous croyons que l'excellence naît de l'alliance entre rigueur stratégique et intégrité professionnelle.
              </p>
            </div>
          </div>

          {}
          <div className="col-span-1 lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6">
            {values.map((item, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-${i * 100}`}>
                <Card className="h-full bg-card/40 border-border/50 hover:bg-card/60 hover:border-primary/30 transition-colors duration-300 backdrop-blur-sm">
                  <CardContent className="p-8 flex flex-col gap-4">
                    <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center mb-2 border border-primary/20">
                      {item.icon}
                    </div>
                    <h3 className="text-xl font-semibold font-sans tracking-tight text-foreground">
                      {item.title}
                    </h3>
                    <p className="leading-relaxed !text-[hsl(0,0%,100%)]">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}